import { useBasketItem } from '~/hooks/use-basket-item';
import ServiceSwitcherCore from './service-switcher-core';
import { QUOTE_API } from '~/lib/constants';
import { BasketQuote } from '~/lib/types/basket-types';
import { BasketSections } from '~/lib/types/enums';
import { useMemo } from 'react';
import { isQuoteDropOff, QuoteFilterOptions } from '~/lib/quotes';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { PublicSettings } from '~/lib/ui-serverless-settings';

/** Used for a specific basket item ID when the basket current item is not set.
 * If basket current item is set, use BasketServiceSwitcher. */
export default function BasketItemServiceSwitcher({
  currentItemId,
  open,
  onClose
}: {
  currentItemId: string;
  open: boolean;
  onClose: () => void;
}) {
  const { basketId, changeService, item, payload } = useBasketItem<BasketQuote>({
    name: BasketSections.QUOTE,
    itemId: currentItemId
  });

  const { settings } = useTenant();

  const defaultFilter: QuoteFilterOptions | undefined = useMemo(
    () =>
      payload && settings[PublicSettings.QUOTES.SERVICEOPTIONSENABLED] === 'true'
        ? ({
            serviceType: isQuoteDropOff(payload) ? 'Drop Off' : 'Collection',
            sortType: isQuoteDropOff(payload) ? 'Closest' : 'Price'
          } as QuoteFilterOptions)
        : undefined,
    [payload, settings]
  );

  return (
    <ServiceSwitcherCore
      intent="SWITCH"
      open={open}
      onClose={onClose}
      quoteUrl={`${QUOTE_API}/quote/basket/${basketId}?itemIds=${currentItemId}&service=`}
      changeService={changeService}
      item={item}
      quoteDefaultFilter={defaultFilter}
      maxHeight="75vh"
    />
  );
}
